module.exports = __webpack_public_path__ + "img/GENERAL-JIMNY-1.8f288865.jpg";